// extracted by mini-css-extract-plugin
export default {"component":"styles__component--Bk50J","tabs":"styles__tabs--ahjNr","card":"styles__card--YX_b6","shareButton":"styles__shareButton--iMGCy","top":"styles__top--NxZIE"};